import { Injectable } from '@angular/core';

/**
 * Simple service to persist small UI state for panels.
 * Stores values in-memory and mirrors them to sessionStorage so state survives component re-creation
 * during navigation or parameter changes within a single browser session.
 */
@Injectable({ providedIn: 'root' })
export class PanelStateService {
  private readonly prefix = 'panelState:';

  // In-memory cache to avoid repeated parsing
  private cache = new Map<string, string | null>();

  public get(key: string): string | null {
    if (this.cache.has(key)) {
      return this.cache.get(key) ?? null;
    }

    const raw = sessionStorage.getItem(this.prefix + key);
    this.cache.set(key, raw);
    return raw;
  }

  public set(key: string, value: string | null): void {
    this.cache.set(key, value);

    if (value === null) {
      this.clear(key);
    } else {
      sessionStorage.setItem(this.prefix + key, value);
    }
  }

  public clear(key: string): void {
    this.cache.delete(key);
    if (sessionStorage.getItem(this.prefix + key)) {
      sessionStorage.removeItem(this.prefix + key);
    }
  }
}
